export default ngModule => {

    ngModule.directive('appScaffold', (AonConfig) => {
        return {
            restrict: 'E',
            transclude: true,
            template: `
            <div>
              <ng-include src="'/static/app-header.html'"></ng-include>
                <div ng-transclude></div>
              <ng-include src="'/static/app-footer.html'"></ng-include>
            </div>
            `,
            link: (scope) => {
                scope.corporate = AonConfig.corporate;
                scope.deployment = AonConfig.deployment;
            },
        };
    });

}



// WEBPACK FOOTER //
// ./src/directives/app-scaffold.js